import { Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'ple-search',
  templateUrl: './ple-search.component.html',
  styleUrls: ['./ple-search.component.scss'],
})

export class  SearchComponent implements OnInit {
    searchText: string = '';
    constructor() {}
    @Output() searchFieldEventEmitter = new EventEmitter<string>();
    @Input() data;
    question: string;
    callSearchFieldEventEmitter(): any {
      this.searchFieldEventEmitter.emit(this.searchText);
    }

    clearSearchText():any{
      this.searchText='';
    }

    ngOnInit(): void {
      this.question=(this.data) ? this.data : 'Search';
    }

}
